import { EventQueueRowData, UnitQueueRowData } from '../../../socket/stream-types';
import { MinutesCell } from '../../../queues/components/cells/common/minutes-cell';
import { getEventQueueRowData } from '../../../queues/utils/get-event-queue-row-data';

export function StandingMinutesCell({
    data,
}: {
    data: EventQueueRowData | UnitQueueRowData;
}): React.ReactElement {
    return <MinutesCell date={getEventQueueRowData(data)?.timeTransmitted} />;
}
